"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-BearingInput',
    label: 'c-BearingInput__label',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center',
    },
};
//# sourceMappingURL=bearing.input.style.js.map